module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vurin13-178684d1a417397684e838253c1b6550.jpg";